export const HIDE_NAVIGATION_QUERY_PARAM = 'no-nav';
export const EMBEDDED_QUERY_PARAM = 'embedded';
